import styled from '@emotion/styled';

export const Container = styled.div`
    padding:10px;
    width:100%:
`

export const H1 = styled.h1`
    color: pink
`